import { createSelector } from "reselect";

export const getAuthToken = createSelector(
  state => state.get("appReducer"),
  appState => appState.get("token")
);
